<nz-tabset [(nzSelectedIndex)]="selectedLogTabIndex" class="log-source-tabs" [testId]="'log-source-tabs'">
  <nz-tab [nzTitle]="'log.operation-tab' | i18n" [testId]="'log-operation-tab'">
    <div class="page-container" [testId]="'log-list-container'">
      <div class="search-section" [testId]="'search-section'">
        <div nz-row [nzGutter]="24" class="search-row" [testId]="'search-row'">
          <div nz-col [nzXs]="24" [nzSm]="24" [nzMd]="8" [nzLg]="8" class="search-input-container" [testId]="'search-input-container'">
            <nz-input-group [nzSuffix]="suffixIconSearch" class="search-input" [testId]="'search-input-group'">
              <input
                type="text"
                nz-input
                placeholder="{{ 'log.search-placeholder' | i18n }}"
                [(ngModel)]="filterParams.keywords"
                (keyup.enter)="search()"
                [testId]="'search-input'"
              />
              <ng-template #suffixIconSearch [testId]="'search-icon-template'">
                <span
                  *ngIf="filterParams.keywords"
                  nz-icon
                  nzType="close-circle"
                  nzTheme="fill"
                  class="ant-input-clear-icon mr-xs"
                  (click)="filterParams.keywords = ''; search()"
                  [testId]="'search-clear-icon'"
                ></span>
                <i
                  nz-icon
                  nzType="search"
                  (click)="search()"
                  class="search-icon"
                  nz-tooltip
                  [nzTooltipTitle]="'log.search-tooltip' | i18n"
                  [testId]="'search-icon'"
                ></i>
              </ng-template>
            </nz-input-group>
            <button
              nz-button
              nzType="default"
              (click)="resetSearch()"
              class="reset-button"
              nz-tooltip
              [nzTooltipTitle]="'log.reset' | i18n"
              [testId]="'reset-button'"
            >
              <i nz-icon nzType="clear" [testId]="'reset-icon'"></i>
            </button>
            <button
              nz-button
              nzType="default"
              (click)="openFilterPopup()"
              class="reset-button"
              nz-tooltip
              [nzTooltipTitle]="'log.advanced-search' | i18n"
              [testId]="'filter-button'"
            >
              <i nz-icon nzType="filter" nzTheme="outline" [testId]="'filter-icon'"></i>
            </button>

            <!-- 列选择下拉菜单 -->
            <button
              nz-button
              nzType="default"
              class="reset-button"
              nz-dropdown
              [nzDropdownMenu]="columnMenu"
              nzTrigger="click"
              nz-tooltip
              [nzTooltipTitle]="'log.column-settings' | i18n"
              [testId]="'column-settings-button'"
            >
              <i nz-icon nzType="setting" [testId]="'column-settings-icon'"></i>
            </button>
            <nz-dropdown-menu #columnMenu="nzDropdownMenu">
              <ul nz-menu [testId]="'column-menu'">
                <li nz-menu-item *ngFor="let col of allColumns" [testId]="'column-menu-item-' + col.key">
                  <label
                    nz-checkbox
                    [ngModel]="selectedColumnKeys.includes(col.key)"
                    (ngModelChange)="onColumnChecked(col.key, $event)"
                    [testId]="'column-checkbox-' + col.key"
                  >
                    {{ col.title }}
                  </label>
                </li>
              </ul>
            </nz-dropdown-menu>
          </div>
        </div>
      </div>
      <div class="filter-section" *ngIf="hasActiveFilters()" [testId]="'filter-section'">
        <div nz-row [nzGutter]="24" [testId]="'filter-row'">
          <div nz-col [nzXs]="24" [nzSm]="24" [nzMd]="24" [nzLg]="24" class="filter-tags-container" [testId]="'filter-tags-container'">
            <div class="filter-tags" [testId]="'filter-tags'">
              <nz-tag
                *ngFor="let item of getActiveFilters(); let i = index"
                [nzColor]="'blue'"
                nzMode="closeable"
                (nzOnClose)="clearFilter(item.key)"
                [attr.data-key]="item.key"
                [testId]="'filter-tag-' + i"
              >
                {{ item.label }}: {{ item.value }}
              </nz-tag>
            </div>
          </div>
        </div>
      </div>

      <!-- 可滚动的内容区域 -->
      <div class="table-section" [class.is-empty]="!listOfData.length" [testId]="'table-section'" (scroll)="syncHorizontalScroll($event)">
        <div class="table-scroll-content" [style.width]="listOfData.length ? tableScrollX : '100%'">
          <nz-table
            #basicTable
            class="content-table"
            nzSize="small"
            [(nzPageIndex)]="pageIndex"
            [(nzPageSize)]="pageSize"
            [nzData]="listOfData"
            [nzFrontPagination]="false"
            [nzShowPagination]="false"
            [nzLoading]="loading"
            [testId]="'log-table'"
          >
            <thead [testId]="'table-head'">
              <tr [testId]="'header-row'">
                <th scope="col" nzWidth="60px" nzLeft class="text-center row-number-column" [testId]="'header-serial-number'">{{
                  'log.serial-number' | i18n
                }}</th>
                <th
                  scope="col"
                  *ngFor="let column of columns; let i = index"
                  nz-resizable
                  [nzWidth]="getColumnWidth(column.key)"
                  (nzResizeEnd)="onResize($any($event), column.key)"
                  [testId]="'header-' + column.key"
                >
                  {{ column.title }}
                </th>
              </tr>
            </thead>

            <tbody [testId]="'table-body'">
              <tr
                *ngFor="let data of basicTable.data; let i = index"
                (dblclick)="openLogDetail(data)"
                [class.clickable]="true"
                [testId]="'data-row-' + i"
              >
                <td nzLeft class="text-center row-number-column" [testId]="'cell-serial-' + i">{{ i + 1 }}</td>
                <td
                  *ngFor="let column of columns; let colIndex = index"
                  [class]="'column-' + column.key"
                  [testId]="'cell-' + column.key + '-' + i"
                >
                  <ng-container [ngSwitch]="column.key">
                    <!-- 时间格式化 -->
                    <ng-container *ngSwitchCase="'requestTime'" [testId]="'time-container-' + i">
                      {{ data[column.key] | date: 'yyyy-MM-dd HH:mm:ss.SSS' }}
                    </ng-container>

                    <ng-container *ngSwitchCase="'timeCost'" [testId]="'cost-container-' + i"> {{ data[column.key] }} ms </ng-container>
                    <ng-container *ngSwitchCase="'hasError'" [testId]="'error-container-' + i">
                      <nz-tag [nzColor]="data[column.key] === true ? 'error' : 'success'" [testId]="'status-tag-' + i">
                        {{ data[column.key] === true ? ('log.failed' | i18n) : ('log.success' | i18n) }}
                      </nz-tag>
                    </ng-container>
                    <!-- 默认显示 -->
                    <ng-container *ngSwitchDefault [testId]="'default-container-' + i">
                      <span class="truncate-text" [title]="data[column.key]" [testId]="'text-span-' + column.key + '-' + i">{{
                        data[column.key]
                      }}</span>
                    </ng-container>
                  </ng-container>
                </td>
              </tr>
            </tbody>
          </nz-table>
        </div>
      </div>
      <div
        class="table-horizontal-scrollbar"
        *ngIf="listOfData.length > 0"
        [class.is-scrollable]="tableScrollX !== '0px'"
        (scroll)="syncTableScroll($event)"
        role="scrollbar"
        aria-orientation="horizontal"
        [attr.aria-valuemax]="tableScrollX"
        [testId]="'table-horizontal-scrollbar'"
      >
        <div class="table-horizontal-scrollbar-track" [style.width]="tableScrollX"></div>
      </div>
      <div class="pagination-section" *ngIf="paginationTotal > 0" [testId]="'pagination-section'">
        <div class="pagination-info" [testId]="'pagination-info'">{{ 'common.total-records' | i18n: { total: paginationTotal } }}</div>
        <div class="pagination-controls" [testId]="'pagination-controls'">
          <nz-pagination
            nzSize="small"
            [nzShowQuickJumper]="true"
            [nzPageIndex]="pageIndex"
            [nzTotal]="paginationTotal"
            [nzPageSize]="pageSize"
            [nzShowSizeChanger]="true"
            [nzPageSizeOptions]="[10, 20, 50, 100]"
            (nzPageIndexChange)="nzPageIndexChange($event)"
            (nzPageSizeChange)="nzPageSizeChange($event)"
            [testId]="'pagination'"
          />
        </div>
      </div>
    </div>
  </nz-tab>
  <nz-tab [nzTitle]="'log.gcp-tab' | i18n" [testId]="'log-gcp-tab'">
    <app-gcp-log-list />
  </nz-tab>
</nz-tabset>
